<template>
  <!-- <div class="navigationBox"  
    :style="{backgroundImage:'url(\'' + backgroundImage + '\')',
    height: (isShow_background ? '360px' : '60px'),
    background: (isShow_background ? 'url(\'' + backgroundImage + '\')' : '#222328')}"> -->
	
	<div class="navigationBox"
	  :style="{backgroundImage:'url(\'' + (isShow_background ? backgroundImage:'') + '\')',
	   height: (isShow_background && activeIndex == 0 ? carouselDtHeight : (isShow_background ? '360px' : '75px'))}"
	   
	  > 
   
	 <div class="flex-row  justify-between menulist">
	   <div class="flex-row align-center navigete-box"> 
		   <img class="logobg" src="@/assets/home/logo@3x(1).png" />
		   <el-menu
			default-active="activeMenu"
			class="align-center"
			@select="handleSelect"
			text-color="#fff"
			:router="false"
			active-text-color="#fff">
			  
			<el-menu-item v-for="item in options" :key="item.index" style="padding: 0 10px;"
			  :class=" Number(activeIndex) == item.index ? 'active' : '' " 
			  :index="item.index">{{item.value}}</el-menu-item>
		   </el-menu>
		</div>
		<div class="flex-row align-center">
			<div class="flex-row align-center" v-if="isLogin">
				<img class="msg-icon"  @click="gotoImList" src="@/assets/home/msg.png"/>
				<img class="msg-icon"  @click="gotoMsg" style="margin-left: 37px;" src="@/assets/home/msg_notice.png"/>  
				<div class="user-name" @click="$store.state.userName ? personalCenter() : setMyInfo()" v-if="$store.state.userType == 3">你好，{{$store.state.companyName}}</div>
				<div class="user-name" @click="$store.state.userName ? personalCenter() : setMyInfo()" v-if="$store.state.userType == 2">你好，{{$store.state.userName}}</div>
			
				<img class="user-avatar" @click="$store.state.userName ? personalCenter() : setMyInfo()" style="cursor: pointer" v-if="$store.state.userImg" :src="$store.state.userImg.indexOf('http') > -1 ? $store.state.userImg : uploadImgAddress + $store.state.userImg"
					alt="" />
				<span v-else class="noUserImg" @click="$store.state.userName ? personalCenter() : setMyInfo()"></span>
				
				<span style="cursor: pointer;margin-left: 10px;" class="user-name" @click.stop="tuichu">退出</span>
			</div>
			<div v-else class="flex-row align-center">
				<div class="navigete-box-login" @click="loginHandle('/login')">登录</div>
				<div class="navigete-box-reg" @click="loginHandle('/register')">注册</div>
			</div> 
		</div>
     </div>
 
    <!-- 首页显示 -->
    <div v-if="activeIndex == 0" class="indexPageIMgsBox"    id="ecarousel">
      <el-carousel trigger="click" :height="carouselHeight" indicator-position="none" :autoplay="false">
      <el-carousel-item v-for="item in indexPageImgs" :key="item.id" >
		  
		<div style="height: 100%;" v-if="item.type == 'video'">
			<video  autoplay="autoplay" style="height: 100%;" muted="muted" loop="loop" preload="auto" poster="/img/bgg.bfde5c56.png" id="videoID" class="banner_video" >
				 <source data-v-674a2b3a="" :src="item.video.indexOf('http')>-1 ? item.video : urlImageAddress + item.video"  type="video/mp4">
			</video>
			<div class="textBox">
				<div class="textBoxTitle">能源行业综合服务平台</div>
				<div class="textBoxSub flex-row align-center justify-center">
					<img class="textBoxSubIcon" src="@/assets/home/dd.png">
					<div class="textBoxSubTitle">Energy industry comprehensive service platform</div>
					<img class="textBoxSubIcon" src="@/assets/home/ddd.png">
				</div>
			</div>
			<div class="videoTips">
				 <img class="videoTipsIcon" src="@/assets/home/x2.png">
				 <div class="videoTipsText">向下滑动 查看更多</div>
				 <img class="videoTipsIcon" style="margin-right: 2px;" src="@/assets/home/x1.png">
			</div>
		 </div>
         <img class="indexImgClass"  v-if="item.type=='image'" :src="urlImageAddress + item.image" alt="" @click="toPage(item)">
         </el-carousel-item>
       </el-carousel>
		<div class="real-time-dynamic flex-row align-center"> 
			 <div class="real-time-dynamic-first">
				 <div class="real-time-dynamic-first-title">{{realTimeDynamicDesc[r_index].realTimeDynamicTitle}}</div>
				 <div class="real-time-dynamic-first-sub_title">{{realTimeDynamicDesc[r_index].realTimeDynamicSubTitle}}</div>
			 </div>
			 
			 <div @mouseover="handleMouseOver(0)" @click="gotoNav('/information')" class="real-time-dynamic-item-box">
				  <img class="real-time-dynamic-item"  src="@/assets/home/1@3x.png">
				  <div class="real-time-dynamic-item-active" v-show="r_index == 0"></div>
			 </div>
			 <div @mouseover="handleMouseOver(1)" @click="gotoNav('/recruitment/postList')" class="real-time-dynamic-item-box">
			 	 <img class="real-time-dynamic-item" src="@/assets/home/2@3x.png">
				 <div class="real-time-dynamic-item-active" v-show="r_index == 1"></div>
			 </div>
			 <div @mouseover="handleMouseOver(2)" @click="gotoNav('/opportunity/tender')" class="real-time-dynamic-item-box">
			 	<img class="real-time-dynamic-item" src="@/assets/home/3@3x.png">
				<div class="real-time-dynamic-item-active" v-show="r_index == 2"></div>
			 </div>
			 <div @mouseover="handleMouseOver(3)" @click="gotoNav('/training/enlist')" class="real-time-dynamic-item-box">
			 	<img class="real-time-dynamic-item" src="@/assets/home/4@3x.png">
				<div class="real-time-dynamic-item-active" v-show="r_index == 3"></div>
			 </div>
			 <div @mouseover="handleMouseOver(4)" @click="gotoNav('/cooperate')" class="real-time-dynamic-item-box">
			 	<img class="real-time-dynamic-item"  src="@/assets/home/5@3x.png">
				<div class="real-time-dynamic-item-active" v-show="r_index == 4"></div>
			 </div> 
		</div>
    </div>
	
    <!-- 非个人中心显示 -->
    <blockquote v-if="isShow_background && activeIndex !== 0">
      <div v-if="!jobInfo && !enterpriseInfo" class="flex-col align-start justify-center navigation_title">
        <span class="title">{{title1}}</span>
        <span class="title">{{title2}}</span>
      </div>
      <!-- 招聘大厅-岗位信息 -->
      <div v-if="jobInfo" class="flex-col align-start justify-start navigation_title">
        <div class="flex-row align-start justify-between line1">
          <span class="">招聘中</span><span class="">{{$tools.str2FormatTime(jobInfo.publishTime,1)}}刷新</span>
        </div>
        <div class="flex-row align-start justify-between line2">
          <span class="">{{jobInfo.name}}
		    <span >{{jobInfo.type != "全职" && jobInfo.type != null ? "("+jobInfo.type+")":''}}</span>
		  </span>
		 
		  <span class="">{{jobInfo.salaryName}}</span>
        </div>
        <div class="flex-row align-start justify-center line3">
          <img src="@/assets/recruitment/i1.png" alt=""/>
          <span class="">{{jobInfo.areaName}}</span>
          <img src="@/assets/recruitment/i2.png" alt=""/>
          <span class="">{{jobInfo.educationBackgroundName}}</span>
          <img src="@/assets/recruitment/i4.png" alt=""/>
          <span class="">{{jobInfo.experienceName}}</span>
          <template v-if="jobInfo.certificateTypeName">
            <img src="@/assets/recruitment/i6.png" alt=""/>
            <span class="">{{jobInfo.certificateTypeName}}</span>
          </template>
        </div>
        <div class="flex-row align-start justify-center line4">
          <span class="align-center justify-center" 
              @click="isCollect ? cancelCollectPosition(jobInfo.id) : collectPosition(jobInfo.id)">
              {{isCollect ? '取消收藏' : '收藏'}}</span>
          <span class="align-center justify-center" @click="onlineCommunication(jobInfo)">立即沟通</span>
        </div>
      </div>
      <!-- 招聘大厅-招聘01企业信息 -->
      <div v-if="enterpriseInfo" class="flex-col align-start justify-start navigation_title">
        <div class="flex-row align-start justify-between" style="width: 100%;">
          <div class="flex-row align-start justify-start line5">
            <img :src="enterpriseInfo.logo.indexOf('http') > -1 ? enterpriseInfo.logo : urlImageAddress + enterpriseInfo.logo" alt="" />
            <div class="flex-col align-start justify-center" style="margin: auto;">
              <span>{{enterpriseInfo.name}}</span>
              <span class="info">{{enterpriseInfo.companyTypeName}} &nbsp;&nbsp; {{enterpriseInfo.companyScaleName}}&nbsp;&nbsp;{{enterpriseInfo.companyIndustryName}}</span>
            </div>
          </div>
          <div class="align-center justify-center right"><span>{{enterpriseInfo.openPosition}}</span>在招职位</div>
        </div>
        <div class="flex-row align-start justify-center line4">
          <span class="align-center justify-center" 
              @click="isFollowCompany ? cancelFollowCompany(enterpriseInfo.id) : followCompany(enterpriseInfo.id)">
              {{isFollowCompany ? '取消关注' : '关注'}}</span>
        </div>
      </div>
    </blockquote>
  </div>
</template>

<script>
import {CollectPosition, CancelCollectPosition, CancelFollowCompany, FollowCompany,getIndexPageImgs} from "@/api/recruitment";
import {
		GetUserNotificationCount
	} from "@/api/common";
export default {
  name: 'navigation',
  data(){
    return {
	   r_index:0,
       realTimeDynamicDesc:[
		  {realTimeDynamicTitle:"时政动态_",realTimeDynamicSubTitle:"国内要闻/行业动态/政策法规/国企招聘，展示能源行业最新动态，致力于帮助用户了解市场"},
		  {realTimeDynamicTitle:"热招岗位_",realTimeDynamicSubTitle:"才华这里绽放，梦想即刻启航——加入我们，共赴职场巅峰！"},
		  {realTimeDynamicTitle:"业内商机_",realTimeDynamicSubTitle:"探索未见领域，发掘无限可能——寻商机，开启财富新篇章！"},
		  {realTimeDynamicTitle:"培训中心_",realTimeDynamicSubTitle:"提升技能，拓宽视野——培训引领职场新飞跃，专业成就未来领先者！"},
		  {realTimeDynamicTitle:"合作发展_",realTimeDynamicSubTitle:"携手共创辉煌，合作共赢未来——聚力同发展，绘就成功新蓝图！"}
	  ],
	  isLogin: false, //是否已登录
      urlImageAddress: process.env.VUE_APP_URL_IMG,  //拼接图片地址
      // 导航栏
      options: [{
          value: '首页',
          index: '0',
          path:'/home'
        }, {
          value: '行业资讯',
          index: '1',
          path:'/information'
        },{
          value: '培训中心',
          index: '2',
          path: '/training'
        },{
          value: '咨询服务',
          index: '3',
          path: '/consulting'
        },
        // {
        //   value: '行业专家',
        //   index: '5',
        //   path: '/experts'
        // },
        {
          value: '业内商机',
          index: '6',
          path: '/opportunity'
        },{
          value: '合作发展',
          index: '7',
          path: '/cooperate'
      }],
      // 首页轮播图数据
      indexPageImgs:[],
      // textActive: 'productionEntity', //路由标识 
      activeIndex: sessionStorage.getItem('activeIndex'),// 当前激活的页面index
      title1: '',
      title2: '',
      backgroundImage: '',

      // nav背景信息更新
      isShow_background: true, // 是否显示nav背景信息(个人中心需隐藏)
      jobInfo: '', // 招聘大厅-岗位信息
      isCollect: null,
      enterpriseInfo: '', // 招聘大厅-企业信息
      isFollowCompany: null,
      userType: null, 
	  uploadImgAddress: process.env.VUE_APP_URL_IMG, // 图片显示路径
	  carouselHeight: null,
	  carouselDtHeight:null,
    }
  },
  computed: {
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
  },
  created(){ 
    this.userType = JSON.parse(localStorage.getItem('identity')); // 2个人， 3企业
    // if(localStorage.getItem('identity')){
      // 企业用户屏蔽“招聘大厅”
      if(this.userType != 3 ) {
        this.options.splice(4, 0, {
          value: '招聘大厅',
          index: '4',
          path: '/recruitment'
        });
      }
	  if(this.userType == 3 ) {
	    this.options.splice(4, 0, {
	      value: '企业中心',
	      index: '4',
	      path: '/enterpriseCenter/position'
	    });
	  }
    // }
  },
  mounted() {
	this.$nextTick(() => {
		const ecarousel = document.getElementById('ecarousel');
		ecarousel.style.height = window.innerHeight + 'px'; // 设置应用程序高度为视口高度
		this.carouselHeight = window.innerHeight + 'px'
		this.carouselDtHeight = window.innerHeight + 310 + 'px'
	});  
	
	if (localStorage.getItem("sessionToken")) {
	  this.isLogin = true;
	  let type = localStorage.getItem('identity') == 2 ? 1 : 2; // 1个人消息 2企业消息
	  this.getUserNotificationCount(type);
	} else {
   	  this.isLogin = false
	}
	  
    this.activeIndex = sessionStorage.getItem('activeIndex') ? sessionStorage.getItem('activeIndex') : 0;
    // this.handleSelect(this.activeIndex);
    if(this.activeIndex < 8) {
      this.$nextTick(() => {
        this.setInfo();
        this.setBgInfo();
      })
    }else{
      this.isShow_background = false;
    }
  },
  watch:{
    $route:function(){
      this.options.forEach(op => {
        var key = op.index; 
        // if(this.userType == 3 && op.index > 4) key = key -1;
        if(this.$route.path.indexOf(op.path) > -1 ){
          sessionStorage.setItem('activeIndex', key);
          return;
        } 
      }) 
      this.activeIndex = sessionStorage.getItem('activeIndex') ? sessionStorage.getItem('activeIndex') : 0;
	  // console.log('activeIndexactiveIndexactiveIndex',this.activeIndex)
      if(this.$route.path.indexOf('postDetails') > -1 || this.$route.path.indexOf('enterpriseDetails') > -1) { // 招聘大厅
        this.backgroundImage = require('@/assets/recruitment/nav_bg_.png');
        this.isShow_background = true;
      }else if(this.$route.path.indexOf('enterpriseCenter') > -1 || this.$route.path.indexOf('personalCenter') > -1 || this.$route.path.indexOf('agreement') > -1){  // 个人中心
        this.isShow_background = false;
      }else{
        sessionStorage.setItem('jobInfo', '');
        sessionStorage.setItem('enterpriseInfo', '');
        this.$store.commit('SET_ISSHOWJOBINFO', true)
        this.isShow_background = true;
        this.setInfo();
      }
      this.setBgInfo();
      console.log('isShow_background',this.isShow_background);

      // console.log(this.jobInfo, this.$route.path.indexOf('postDetails'))
    },
  },
  methods:{
	  gotoNav(path){
		  this.$router.push({
		  	path: path,
		  	query: {}
		  }, () => {});
	  },
	  //鼠标悬浮事件
	  handleMouseOver(index){
		this.r_index = index
	  },
	  // 获取消息数量
	  getUserNotificationCount(type) {
	  	GetUserNotificationCount({
	  		model: {
	  			type: type // 1个人消息 2企业消息
	  		}
	  	}).then(res => {
	  		this.$store.commit('SET_NOTIFICATIONCOUNT', res.count)
	  	})
	  },
	  //退出
	  tuichu() {  
		  
	  	this.$confirm('确定退出?', '提示', {
	  		confirmButtonText: '确定',
	  		cancelButtonText: '取消',
	  		type: 'warning'
	  	}).then(() => { 
	  		localStorage.clear();
	  		sessionStorage.clear(); 
	  		this.initOP()
	  		this.isLogin = false 
	  		this.$router.push({path: '/',}, () => {})
	  	}).catch(() => {
	  		this.$message({
	  			type: 'info',
	  			message: '已取消退出'
	  		});
	  	});
	  },
	  // 个人信息未完善强制完善，跳转个人信息完善页面
	  setMyInfo() {
	  	this.$router.push({
	  		path: '/login_myinfo',
	  		query: {
	  			identity: JSON.parse(localStorage.getItem('identity')) // 2个人， 3企业,
	  		}
	  	}, () => {});
	  	this.$message.warning('请先完善个人信息！');
	  },
	  
	  //个人中心
	  personalCenter() {
	  	// 区别登录用户身份
	  	let path = localStorage.getItem('identity') == 2 ? '/personalCenter' : '/enterpriseCenter'
 
	  	this.$router.push({
	  		path: path,
	  	}, () => {})
	  },
	  //跳转聊天列表
	  gotoImList(){
	  	let identity = localStorage.getItem('identity');
	  	let path = '';
	  	let query = {}
	  	if (identity == 2) {
	  		 path = "/personalCenter/onlineCommunication/0"
	  	} else {
	  		 path = "/enterpriseCenter/communicate";
	  		 query = {
	  		 	type: 2,
	  		 	status:1
	  		 }
	  	}
	  	this.$router.push({
	  		path: path,
	  		query:query
	  	}, () => {}) 
	  },
	  //跳转消息页面
	  gotoMsg() { 
	  	let path = ''
	  	let identity = localStorage.getItem('identity');
	  	if (identity == 2) {
	  		 path = "/personalCenter/message"
	  	} else {
	  		 path = "/enterpriseCenter/message";
	  	}
	  	this.$router.push({
	  		path: path,
	  		query: {
	  			type: 99,
          current_nav: 0
	  		}
	  	}, () => {})
	  },
	//跳转至登录、注册页
	loginHandle(path) {
		this.$router.push({
			path: path,
			query: {
				id: this.$route.query.id,
				redirect: path == '/login' ? this.$route.path : '',
				type: this.$route.query.type ? this.$route.query.type : 0,
			}
		}, () => {})
	},
    initOP(){ 
      let isIn =  this.options.findIndex(v => (v.path.indexOf('/recruitment')>-1));
      console.log(isIn)
      if(isIn > -1 ) return; 
      this.userType = JSON.parse(localStorage.getItem('identity')); // 2个人， 3企业
      if(this.userType != 3 ) {
        this.options.splice(4, 1, {
          value: '招聘大厅',
          index: '4',
          path: '/recruitment'
        });
      }
    },
    handleSelect(key) {   
      console.log('key',key)
      this.activeIndex = key; 
      sessionStorage.setItem('activeIndex', key);
	  if (key > 5) {
	  	key = key - 1
	  }
      if(localStorage.getItem('identity')){ 
        // if(this.userType == 3 && key > 4) key = key -1;
        // this.activeIndex = key;
        console.log('activeIndex=='+ key, );
		
		 
        if(this.$route.path.indexOf('enterpriseCenter') > -1 || this.$route.path.indexOf('personalCenter') > -1 || this.$route.path.indexOf('agreement') > -1){  // 个人中心
          this.isShow_background = false;
        } 
        this.$router.push({
          path: key < 8 ? this.options[key].path : this.$router.path,
        }, () => {})
      }else{ 
        this.$router.push({
          path: key < 8 ? this.options[key].path : this.$router.path
        }, () => {})
      }
     
    },
  
    setInfo() {
      // if(this.userType == 3 && this.activeIndex > 3) this.activeIndex = Number(this.activeIndex) + 1;
      if(this.activeIndex == 0){
		  
		  this.$nextTick(() => {
		  	const ecarousel = document.getElementById('ecarousel');
		  	ecarousel.style.height = window.innerHeight + 'px'; // 设置应用程序高度为视口高度
		  	this.carouselHeight = window.innerHeight + 'px'
			this.carouselDtHeight = window.innerHeight + 310 + 'px'
		  }); 
		  
        // this.title1 = '建桥搭梁';
        // this.title2 = '为企业和求职者提供连接的桥梁';
        this.title1 = '';
        this.title2 = '';
        this.backgroundImage = require('@/assets/index/nav_bg.png')
        this.getIndexImgs()
      }else if(this.activeIndex == 1){
        this.title1 = '行业资讯';
        this.title2 = 'Industry Information';
        this.backgroundImage = require('@/assets/information/nav_bg.png')
      }else if(this.activeIndex == 2){
        this.title1 = '培训中心';
        this.title2 = 'Training Center';
        this.backgroundImage = require('@/assets/train/nav_bg.png')
      }else if(this.activeIndex == 3){
        this.title1 = '咨询服务';
        this.title2 = 'Advisory Service';
        this.backgroundImage = require('@/assets/consulting/nav_bg.png')
      }
	  else if(this.activeIndex == 4 && this.userType != 3){
        this.title1 = '招聘大厅';
        this.title2 = 'Recruitment Hall';
        this.backgroundImage = require('@/assets/recruitment/nav_bg.png')
      }
	  // else if(this.activeIndex == 5){
   //      this.title1 = '行业专家';
   //      this.title2 = 'Industry Experts';
   //      this.backgroundImage = require('@/assets/experts/nav_bg.png')
   //    }
      else if(this.activeIndex == 6){
        this.title1 = '业内商机';
        this.title2 = 'Industry Opportunities';
        this.backgroundImage = require('@/assets/opportunity/nav_bg.png')
      }else if(this.activeIndex == 7){
        this.title1 = '合作发展';
        this.title2 = 'Cooperative Development';
        this.backgroundImage = require('@/assets/consulting/nav_bg.png')
      }
    },
    setBgInfo(){
      this.$nextTick(() => {
        setTimeout(()=>{
          if(sessionStorage.getItem('jobInfo')){
            this.jobInfo = JSON.parse(sessionStorage.getItem('jobInfo')); 
            this.isCollect = this.jobInfo.isCollect
          } else{
            this.jobInfo = '';
          }

          if(sessionStorage.getItem('enterpriseInfo')){
            this.enterpriseInfo = JSON.parse(sessionStorage.getItem('enterpriseInfo'));
            this.isFollowCompany = this.enterpriseInfo.isFollowCompany
          } else{
            this.enterpriseInfo = '';
          }
        },1000)
      });
    },
    //获取 首页轮播图
    getIndexImgs(){
        getIndexPageImgs({
          action:"getlist",
          model:{}
        }).then(res => {
          this.indexPageImgs = res;
        })
    },
    // 轮播图调到外链
    toPage(item){
      // if (item.jumType == '_blank'){
      //    window.open(item.jumpUrl)
      // } else if(item.jumType == '_self') {
      //    window.location.href= item.jumpUrl
      // }
      let path = item.jumpUrl.split("#")[1]
      this.$router.push({
          path: path,
          query: {}
        }, () => {})
    },

    // 招聘大厅-收藏职位
    collectPosition(id){
      if (localStorage.getItem("sessionToken")){
        CollectPosition({
          model: {collectId: id}
        }).then((res) => {
          this.isCollect = true;
          if(res) this.$message({
                  message: '收藏成功！',
                  type: 'success'
                });
          else this.$message({
                  message: '收藏失败！',
                  type: 'error'
                });
        })
      }else {
        // this.$message.warning('您还未登录！');
        this.$router.push({
          path: '/login',
          query: {
            id: id,
            redirect: this.$route.path,
            type: this.$route.query.type ? this.$route.query.type : 0,
          }
        }, () => {})
      }
    },
    // 招聘大厅-取消收藏职位
    cancelCollectPosition(id){
      if (localStorage.getItem("sessionToken")){
        CancelCollectPosition({
          model: {collectId: id}
        }).then((res) => {
          this.isCollect = false;
          if(res) this.$message({
                    message: '已取消收藏！',
                    type: ''
                  });
          else  this.$message({
                  message: '取消收藏失败！',
                  type: 'error'
                });
        })
      }else {
        // this.$message.warning('您还未登录！');
        this.$router.push({
          path: '/login',
          query: {
            id: id,
            redirect: this.$route.path,
            type: this.$route.query.type ? this.$route.query.type : 0,
          }
        }, () => {})
      }
    },
    // 招聘大厅-关注企业
    followCompany(id){
      if (localStorage.getItem("sessionToken")){
        FollowCompany({
          model: {collectId: id}
        }).then((res) => {
          this.isFollowCompany = true;
          if(res) this.$message({
                  message: '关注成功！',
                  type: 'success'
                });
          else this.$message({
                  message: '关注失败！',
                  type: 'error'
                });
        })
      }else {
        // this.$message.warning('您还未登录！');
        this.$router.push({
          path: '/login',
          query: {
            id: id,
            redirect: this.$route.path,
            type: this.$route.query.type ? this.$route.query.type : 0,
          }
        }, () => {})
      }
    },
    // 招聘大厅-取消关注企业
    cancelFollowCompany(id){
      if (localStorage.getItem("sessionToken")){
        CancelFollowCompany({
          model: {collectId: id}
        }).then((res) => {
          this.isFollowCompany = false;
          if(res) this.$message({
                  message: '已取消关注！',
                  type: 'success'
                });
          else this.$message({
                  message: '取消失败！',
                  type: 'error'
                });
        })
      }else {
        // this.$message.warning('您还未登录！');
        this.$router.push({
          path: '/login',
          query: {
            id: id,
            redirect: this.$route.path,
            type: this.$route.query.type ? this.$route.query.type : 0,
          }
        }, () => {})
      }
    },
    // 立即沟通
    onlineCommunication(jobInfo){
      // console.log(jobInfo)
      if (localStorage.getItem("sessionToken")){
        this.$router.push({
            path: '/personalCenter/onlineCommunication/' + 0,
            query: {
              positionId: jobInfo.id,
              type: 2,
              userId: jobInfo.userInfo.id,
              name: jobInfo.userInfo.name,
              avatar: jobInfo.userInfo.userImg,
            }
        })
      }else {
          // this.$message.warning('您还未登录！');
          this.$router.push({
            path: '/login',
            query: {
              id: jobInfo.id,
              redirect: this.$route.path,
              type: this.$route.query.type ? this.$route.query.type : 0,
            }
          }, () => {})
        }
    }
    
    
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/index.scss"; 
	.real-time-dynamic-item-active{
		width: 214px;
		height: 8px;
		background: #0056E2;
		border-radius: 0px 0px 0px 0px;
		position: absolute;
		bottom:0;
	}
	.real-time-dynamic-item-box{
		position: relative;
	}
	.real-time-dynamic-item{
		width: 234px;
		height:200px;
		cursor: pointer; 
	}
	.real-time-dynamic-first-sub_title{
		font-size: 12px;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 400;
		color: #111111;
		line-height: 21px;
		margin-top: 2.2rem; 
		display: -webkit-box; /* 必须 */
		overflow: hidden; /* 必须 */
		text-overflow: ellipsis; /* 必须 */
		-webkit-line-clamp: 2; /* 必须 */
		-webkit-box-orient: vertical; /* 必须 */
	}
	.real-time-dynamic-first-title{
		font-size: 34px;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 700;
		color: #111111;
		// line-height: 34px;
		margin-top:37px; 
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.real-time-dynamic-first{
		width: 300px;
		height:200px; 
		background: url(@/assets/home/ssdtt.png) no-repeat;
		background-size:100% 100%;
		padding:25px;
	}
	.real-time-dynamic{
		height: 310px;
		width:100%;
		background: #FFFFFF;
		box-shadow: 0px 10px 20px 0px #E2E6EE;
		border-radius: 0px 0px 0px 0px;
		padding: 0 10.75%;
	}
	.textBoxSubTitle{
		font-size: 32px;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 32px;
		margin:0 21px;
	}
	.videoTips{
		position: absolute;
		bottom: 2%;   
		display: flex;
		flex-direction: column;
		width:100%;
		align-items: center;
		justify-content: center;
	}
	.videoTipsText{
		font-size: 14px;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 14px;
		margin:5px 0 14px 0;
	}
	.videoTipsIcon{
		width: 41px;
		height: 41px;
	}
	.textBoxSubIcon{
		width: 35px;
		height: 36px;
	}
	.textBoxSub{
		margin-top: 27px;
	}
	.textBoxTitle{
		font-size: 100px;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 700;
		color: #FFFFFF;
		line-height: 132px;
	}
	.textBox{
		position: absolute;
		top: 30%;
		width:100%;
		text-align: center;
	}
	.navigete-box{
		overflow: hidden;
	}
	.user-name{
		font-size: 16px;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		margin-left:22px;
		margin-right:16px;
		cursor: pointer;
	}
	.msg-icon{
		width: 24px;
		height:24px;
		cursor: pointer;
	}
	.user-avatar{
		width: 44px;
		height: 44px;
		border-radius: 50%;
		border: 2px solid #FFFFFF;
		cursor: pointer;
		margin-right: 10px;
	}
   .noUserImg {
   	width: 44px;
   	height: 44px;
   	margin-right: 10px;
   	border-radius: 50%;
   	border: #E5E5E5 1px solid;
   	background: #E5E5E5;
	cursor: pointer;
  }
 .navigete-box-reg{
	width: 72px;
	height: 36px;
	border-radius: 4px 4px 4px 4px;
	text-align: center;
	line-height: 36px;
	font-size: 16px;
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
    color: #FFFFFF;
	border: 1px solid #FFFFFF;
	margin-left: 13px;
	cursor: pointer;
  }
 .navigete-box-login{ 
	 width: 72px;
	 height: 36px;
	 background: #FFFFFF;
	 border-radius: 4px 4px 4px 4px;
	 text-align: center;
	 line-height: 36px;
	 font-size: 16px;
	 font-family: Microsoft YaHei, Microsoft YaHei;
	 font-weight: 400;
	 color: #3D3D3D;
	  cursor: pointer;
 }
 .logobg{
	 height: 3.25rem;
	 margin-right: 3.75rem;
  }
  
 .navigationBox{
    width: 100%;
    height: 360px;
    // background-image: url('@/assets/index/nav_bg.png');
    // background-image: var(--backgroundImage);
    background-size: 100% 360px;
    background-repeat: no-repeat;
    position: relative;
    .menulist{
	  display: flex;
	  flex-direction: row;
	  align-items: center;
      padding: 0 $padding-both;
      width: 100%;
      height: 4.68rem;
      background-color: rgba(0,0,0,0.5);
      box-shadow: 0px 3px 3px 0px rgba(0,0,0,0.08);
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
        
      ::v-deep .el-menu{
        background-color: rgba(0,0,0,0);
        margin-right: 0;
        border-right: 0;
        width: 100%;
        display: flex;
        // justify-content: space-between;
        li{
          // width: calc( 100% / 8);
          display: flex;
          // flex: 1;
          align-items: center;
          justify-content: center;
          height: 4.68rem;
		  margin-right:2.5rem;
          padding: 0;
          // padding-left: -40px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          &:hover{
            background-color: rgba(0,0,0,0.2);
          }
        }
        .active {
          color: #FFFFFF;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: bold;
          background-color: rgba(0,0,0,0);
        }
      }
    
    }
    // 首页轮播图
    .indexPageIMgsBox{
      width: 100%;
      height: 100%;
      background-color: #008DD6;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 9;
      .indexImgClass{
        width: 100%;
        height: 100%;
      }
    }
    .navigation_title{
      width: 100%;
      height: 300px;
      padding: 0 $padding-both;
      position: absolute;
      top: 60px;
      left: 0;
      .title{
        font-size: 44px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        margin-bottom: 15px;
        &:last-child{
          font-size: 33px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
      .line1{
        width: 100%;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        margin: 40px 0 30px 0;
      }
      .line2{
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        span{
          margin-right: 100px;
        }
      }
      .line3{
        margin: 20px 0 50px 0;
        img{
          width: 16px;
          height: 17px;
          margin-right: 10px;
        }
        span{
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          margin-right: 40px;
        }
      }
      .line4>span{
        &:hover{
          // box-shadow: 5px 5px 5px 5px rgba(255,255,255,0.2);
          transform: scale(1.02);
          cursor: pointer;
        }
        &:nth-child(1){
          width: 194px;
          height: 61px;
          border: 1px solid #FFFFFF;
          border-radius: 10px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          margin-right: 40px;
        }
        &:nth-child(2){
          width: 194px;
          height: 61px;
          background: #FFFFFF;
          border: 1px solid #FFFFFF;
          border-radius: 10px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #008DD6;
        }
      }
      .line5{
        margin-top: 45px;
        margin-bottom: 70px;
        img{
          width: 100px;
          height: 100px;
          background: #E5E5E5;
          border-radius: 5px;
          margin-right: 20px;
        }
        span{
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FFFFFF ;
        }
        .info{
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          margin-top: 15px;
        }
      }
      .right{
        margin-top: 45px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        span{
          font-size: 60px;
          margin-right: 10px;
        }
      }
    }
  }
</style>


